'use client';

import { useState, useEffect } from 'react';



interface TrustItem {
  id: string;
  type: 'certification' | 'award' | 'customer';
  title: string;
  subtitle: string;
  icon?: string;
  image?: string;
  alt?: string;
}

interface TrustSignalsProps {
  className?: string;
}

const TrustSignals: React.FC<TrustSignalsProps> = ({ className = '' }) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const trustItems: TrustItem[] = [
  {
    id: 'soc2',
    type: 'certification',
    title: 'SOC 2 Type II',
    subtitle: 'Security & Compliance',
    icon: 'ShieldCheckIcon'
  },
  {
    id: 'iso27001',
    type: 'certification',
    title: 'ISO 27001',
    subtitle: 'Information Security',
    icon: 'LockClosedIcon'
  },
  {
    id: 'gdpr',
    type: 'certification',
    title: 'GDPR Compliant',
    subtitle: 'Data Protection',
    icon: 'DocumentCheckIcon'
  },
  {
    id: 'hipaa',
    type: 'certification',
    title: 'HIPAA Compliant',
    subtitle: 'Healthcare Data Security',
    icon: 'ShieldCheckIcon'
  },
  {
    id: 'leader2026',
    type: 'award',
    title: 'Industry Leader 2026',
    subtitle: 'Gartner Recognition',
    icon: 'TrophyIcon'
  },
  {
    id: 'innovation',
    type: 'award',
    title: 'Innovation Award',
    subtitle: 'AI Excellence 2026',
    icon: 'StarIcon'
  },
  {
    id: 'customer1',
    type: 'customer',
    title: 'Global Telecom Leader',
    subtitle: '87% Satisfaction Increase',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1429d51dd-1769543215332.png",
    alt: 'Modern telecommunications company office building with glass facade and company logo'
  },
  {
    id: 'customer2',
    type: 'customer',
    title: 'Fortune 500 Bank',
    subtitle: '$2.4M Annual Savings',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_141ebb93f-1774604980451.png",
    alt: 'Prestigious banking headquarters skyscraper in financial district at sunset'
  },
  {
    id: 'customer3',
    type: 'customer',
    title: 'Retail Giant',
    subtitle: '67% Conversion Growth',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ee94cf0-1768855842453.png",
    alt: 'Modern retail store interior with digital displays and customers shopping'
  }];


  useEffect(() => {
    if (!isHydrated) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % trustItems.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isHydrated, trustItems.length]);

  const handleDotClick = (index: number) => {
    if (!isHydrated) return;
    setActiveIndex(index);
  };

  if (!isHydrated) {
    return (
      <section className={`py-16 bg-card border-y border-border ${className}`}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="font-display font-bold text-2xl lg:text-3xl text-foreground mb-2">
              Trusted by Industry Leaders
            </h2>
            <p className="font-body text-base text-muted-foreground">
              Certified, recognized, and proven at enterprise scale
            </p>
          </div>
          <div className="flex justify-center">
            <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
          </div>
        </div>
      </section>);

  }

  return null;
};

export default TrustSignals;